/* ==========================================================================
   主な取扱いジャンルの動画本数ランキング
   ==========================================================================*/
$(function() {
	$('.tab_btn3 .btn:nth-child(1), .tab_btn3 .btn.first').addClass('current');
	$('.tab_btn3 .btn').hover(function() {
		var num = $(this).parent().children('.btn').index(this);
		$(this).parent('.tab_btn3').each(function(){
			$('>.btn',this).removeClass('current').eq(num).addClass('current');
		});
		$(this).parent().next().children('.tab_content3').hide().eq(num).show();
	});
	$('.tab_btn3 .btn.current').hover();

	// オススメ動画取得
	if ($(".tab_content3_area .recommend_loader").length > 0) {
		$(window).on("load scroll", function() {
			var scroll = $(window).scrollTop()+$(window).height();
			$(".tab_content3_area").each(function () {
				if ($(this).find('.recommend_loader').length == 0) {
					return true;
				} else if ($(this).offset().top <= scroll + 200) {
					var num = $(".tab_content3_area").index(this);
					var url = $(this).find('.recommend_loader:first').data('url');
					$(this).find('.recommend_loader').removeClass('recommend_loader');
					$.ajax({
						url: url,
						dataType: "html",
						success: function(data){
							if ($(data).hasClass('tab_content3_area')) {
								var contents = $(data);
							} else {
								var contents = $(data).find(".tab_content3_area");
							}
							contents.hide();
							$('.tab_content3_area').eq(num).replaceWith(contents);
							contents.show(300)
							$('.tab_btn3 .btn.current').hover();
							contents.find("a[rel*='shadowbox']").on('hover', function (e) {
								Shadowbox.open(this);
								e.preventDefault()
							});
              var observer = lozad('.lazy', {
                loaded: function(el) {
                  el.classList.add('is-fade');
                }
              });
              observer.observe();
						},
						error: function () {
							$('.tab_content3_area').eq(num).find('.loader').addClass('recommend_loader')
						}
					});
				}
			});
		});
	}
});

/* ==========================================================================
   スムーススクロール
   ==========================================================================*/
$(function(){
	var headerHight = 98;
	// #で始まるアンカーをクリックした場合に処理(.non_scrollをつけると除外)
	$('a[href^=#]' + 'a:not(.non_scroll)').click(function() {
		// スクロールの速度
		var speed = 400; // ミリ秒
		// アンカーの値取得
		var href= $(this).attr("href");
		// 移動先を取得
		var target = $(href == "#" || href == "" ? 'html' : href);
		// 移動先を数値で取得
		var position = target.offset().top-headerHight; // ※　-headerHightでズレの処理
		// スムーズスクロール
		$('body,html').animate({scrollTop:position}, speed, 'swing');
		return false;
	});
});

/* -----------------------------------------------
 * スクロール固定
 * ----------------------------------------------- */
$(function($){
	function UpdateTableHeaders() {
		$(".multisearch-main-scroll-main").each(function() {
				var el = $(this),
				offset = el.offset(),
				scrollTop = $(window).scrollTop(),
				floatingHeader = $(".floatingHeader", this);

				if ((scrollTop > offset.top) && (scrollTop < offset.top + el.height() - 180)) {
				floatingHeader.css({
				"visibility": "visible"
			});
				} else {
					floatingHeader.css({
					"visibility": "hidden"
				});
			}
		});
	}

	$(function() {
		var clonedHeaderRow;
		$(".multisearch-main-scroll-main").each(function() {
			clonedHeaderRow = $(".multisearch-main-scroll-thead", this);
			clonedHeaderRow
			.before(clonedHeaderRow.clone())
			.css("width", clonedHeaderRow.width(730))
			.addClass("floatingHeader");
		});

		$(window)
		.scroll(UpdateTableHeaders)
		.trigger("scroll");
	});
});

/* -----------------------------------------------
 * 基本項目説明
 * ----------------------------------------------- */
$(function() {
	var $btnEvaluation = $('#js-btn-evaluation'),
      $btnCloseEvaluation = $('#js-btn-close-evaluation'),
      $evaluation = $('#js-evaluation');

  $btnEvaluation.on('click', function() {
    $evaluation.addClass('is-open');
  });
  $btnCloseEvaluation.on('click', function() {
    $evaluation.removeClass('is-open');
  });
});

$(function() {
  var $fixedSide = $('.js-fixed_side'),
      $titleAnchor = $('.js-title_anchor'),
      titleLink = '.js-tile_link';

    // ナビゲーションのリンクを指定
   var navLink = $fixedSide.find(titleLink).find('a');

    // 各コンテンツのページ上部からの開始位置と終了位置を配列に格納しておく
   var contentsArr = new Array();
    for (var i = 0; i < navLink.length; i++) {
         // コンテンツのIDを取得
        var targetContents = navLink.eq(i).attr('href');
        // ページ内リンクでないナビゲーションが含まれている場合は除外する
        if(targetContents.charAt(0) == '#') {
           // ページ上部からコンテンツの開始位置までの距離を取得
              var targetContentsTop = $(targetContents).offset().top;
           // ページ上部からコンテンツの終了位置までの距離を取得
              var targetContentsBottom = targetContentsTop + $(targetContents).outerHeight(true) - 1;
           // 配列に格納
              contentsArr[i] = [targetContentsTop, targetContentsBottom]
        }
     };

    // 現在地をチェックする
     function currentCheck() {
         // 現在のスクロール位置を取得
          var windowScrolltop = $(window).scrollTop();
          for (var i = 0; i < contentsArr.length; i++) {
             // 現在のスクロール位置が、配列に格納した開始位置と終了位置の間にあるものを調べる
            if(contentsArr[i][0] <= windowScrolltop && contentsArr[i][1] >= windowScrolltop) {
                  // 開始位置と終了位置の間にある場合、ナビゲーションにclass="current"をつける
                 navLink.parent('li').removeClass('is-active');
                 navLink.eq(i).parent('li').addClass('is-active');
                  i == contentsArr.length;
              }
         };
    }

    // ページ読み込み時とスクロール時に、現在地をチェックする
    $(window).on('load scroll', function() {
      currentCheck();
    });

    $(window).load(function() {
	  var sideNavPos = $fixedSide.offset().top;
	  var fixedSideHeight = $fixedSide.height();

      $(window).on('scroll', function() {

        var scTop = $(this).scrollTop();
        if (scTop >= sideNavPos) {

		  // フッターに被らないようにメインカラムより下に行かないようにする
		  // ページの高さが変更になってもいいように都度メインカラムの位置取得
		  var sideEnd = $('#main').offset().top + $('#main').height();

		  if(scTop + fixedSideHeight > sideEnd) {
			$fixedSide.css({
				position: 'absolute',
				top: '',
				bottom: 0,
			  });
		  } else {
			$fixedSide.css({
				position: 'fixed',
				top: 0,
				bottom: '',
			  });
		  }
        } else {
          $fixedSide.css({
            position: 'relative',
            top: '',
			bottom: '',
		});
        }
      });
    });
});